import { CssUtils } from "../../../../helpers/css";
import { ObjectUtils } from "../../../../helpers/object";
import { AuthUtils } from "../../../../modules/auth/domain";

const TawreedTableDecimalFormatter = (field: string, scale?: number, alt?: any, style?: any, className: string = '') => {
    //var lang = AuthUtils.current().language;
    return {
        dataType: 'numeric',
        body: (rowData: any) => (rowData[field] || rowData[field] === 0) ? ObjectUtils.toFixed(rowData[field], scale, alt) : undefined,
        style: CssUtils.align('right', style),
        className: `${CssUtils.className.field.amount} ${className}`,
    }
};

const TawreedTableDropdownFormatter = (field: string, formate: (item: any) => React.ReactNode) => {
    return {
        body: (rowData: any) => {
            const value = ObjectUtils.getNested(rowData, field);
            if (value) {
                return formate(value);
            }
            return '';
        },
    }
};
const TawreedTablePercentageFormatter = (field: string, scale: number, alt?: any) => {
    return {
        body: (rowData: any) => ObjectUtils.toFixed(rowData[field], scale, alt) + " %"
    }
};
const TawreedTableCurrencyFormatter = (field: string, scale: number, currencyCode: string, alt?: any) => {
    return {
        body: (rowData: any) => ObjectUtils.toFixed(rowData[field], scale, alt) + ' ' + currencyCode,
    }
};
const TawreedTableCurrencyOrPercentageDependFormatter = (field: string, depend: string, currencyCode: string, scale: number, alt?: any) => {
    return {
        body: (rowData: any) => ObjectUtils.toFixed(rowData[field], scale, alt) + ' ' + (rowData[depend] === 'percentage' ? "%" : rowData[depend] === "fixed" ? currencyCode : "%+"),
    }
};

export const TawreedTableFormatters = {
    decimal: TawreedTableDecimalFormatter,
    dropdown: TawreedTableDropdownFormatter,
    percentage: TawreedTablePercentageFormatter,
    currency: TawreedTableCurrencyFormatter,
    currencyOrPercentageDepend: TawreedTableCurrencyOrPercentageDependFormatter
}
